import axios from "axios";
import * as actionType from "../../../constant/actionType";

/*** GenerateClientOverviewReport Action ***/
export const GenerateClientOverviewReportStart = () => {
    return {
        error: null,
        loader: true,
        isAuthenticated: true,
        type: actionType.GenerateClientOverviewReport_START,
    };
};
export const GenerateClientOverviewReportSuccess = (response) => {
    return {
        error: false,
        loader: false,
        isAuthenticated: response.status === 401 ? false : true,
        type: actionType.GenerateClientOverviewReport_SUCCESS,
    };
};
export const GenerateClientOverviewReportFail = (error) => {
    return {
        error: error,
        loader: false,
        isAuthenticated: error.status === 401 ? false : true,
        type: actionType.GenerateClientOverviewReport_FAIL,
    };
};

export const GenerateClientOverviewReport = ({
    functionId,
    searchTerm,
    filterpage,
    filterlimit,
    filtersort,
    filterorder,
    client_org_ids,
    created_date_range,
    filterStatus,
    renewalDate
}) => {
    return (dispatch) => {
        dispatch(GenerateClientOverviewReportStart());

        const config = {
            method: "get",
            url: `${actionType.environment_url}/api/admin/GenerateClientOverviewReport`,
            headers: {
                Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
            },
            params: {
                function_id: functionId,
                search: searchTerm,
                limit: filterlimit,
                page: filterpage,
                sort: filtersort,
                order: filterorder,
                status: filterStatus,
                client_org_ids: JSON.stringify(client_org_ids),
                created_date_range: created_date_range,
                renewal_date_range:renewalDate
            },
        };

        return axios(config)
            .then(function (response) {
                dispatch(GenerateClientOverviewReportSuccess(response.data));
                return response.data;
            })
            .catch(function (error) {
                dispatch(
                    GenerateClientOverviewReportFail("Something went wrong, Please try again.")
                );
                return error;
            });
    };
};